import { FormattedRpServiceTemplate } from "@idw-types/data/reference-data/generic";

export enum ServiceTemplatesActionTypes {
    SET_SERVICE_TEMPLATES_LOADING = "SET_SERVICE_TEMPLATES_LOADING",
    SET_SERVICE_TEMPLATES = "SET_SERVICE_TEMPLATES",
    ADD_SERVICE_TEMPLATE = "ADD_SERVICE_TEMPLATE"
}

type SetServiceTemplatesLoadingAction = {
    type: ServiceTemplatesActionTypes.SET_SERVICE_TEMPLATES_LOADING,
    payload: { isLoading: boolean; }
};

export const setServiceTemplatesLoading = (isLoading: boolean): SetServiceTemplatesLoadingAction => ({
    type: ServiceTemplatesActionTypes.SET_SERVICE_TEMPLATES_LOADING,
    payload: { isLoading }
});

type SetServiceTemplatesAction = {
    type: ServiceTemplatesActionTypes.SET_SERVICE_TEMPLATES,
    payload: { serviceTemplates: Array<FormattedRpServiceTemplate>; }
}

export const setServiceTemplates = (serviceTemplates: Array<FormattedRpServiceTemplate>): SetServiceTemplatesAction => ({
    type: ServiceTemplatesActionTypes.SET_SERVICE_TEMPLATES,
    payload: { serviceTemplates }
});

type AddServiceTemplateAction = {
    type: ServiceTemplatesActionTypes.ADD_SERVICE_TEMPLATE;
    payload: { serviceTemplate: FormattedRpServiceTemplate };
};

export const addServiceTemplate = (serviceTemplate: FormattedRpServiceTemplate): AddServiceTemplateAction => ({
    type: ServiceTemplatesActionTypes.ADD_SERVICE_TEMPLATE,
    payload: { serviceTemplate }
});

export type ServiceTemplatesActions =
    SetServiceTemplatesLoadingAction |
    SetServiceTemplatesAction |
    AddServiceTemplateAction